import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { makeStyles } from '@material-ui/core/styles';
import {
  purple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  deepPurple
} from '@material-ui/core/colors';
import {
  Avatar,
  Icon,
  IconButton
} from '@material-ui/core';
import {
  getActiveStoreUsersApi,
  deleteUserStoreAPI
} from 'api';


const useStyles = makeStyles((theme) => ({
  purple: {
    color: theme.palette.getContrastText(purple[300]),
    backgroundColor: purple[300]
  },
  deepPurple: {
    color: theme.palette.getContrastText(deepPurple[300]),
    backgroundColor: deepPurple[300]
  },
  indigo: {
    color: theme.palette.getContrastText(indigo[300]),
    backgroundColor: indigo[300]
  },
  blue: {
    color: theme.palette.getContrastText(blue[300]),
    backgroundColor: blue[300]
  },
  lightBlue: {
    color: theme.palette.getContrastText(lightBlue[300]),
    backgroundColor: lightBlue[300]
  },
  cyan: {
    color: theme.palette.getContrastText(cyan[300]),
    backgroundColor: cyan[300]
  },
  teal: {
    color: theme.palette.getContrastText(teal[300]),
    backgroundColor: teal[300]
  },
  green: {
    color: theme.palette.getContrastText(green[300]),
    backgroundColor: green[300]
  },
  lightGreen: {
    color: theme.palette.getContrastText(lightGreen[300]),
    backgroundColor: lightGreen[300]
  },
  lime: {
    color: theme.palette.getContrastText(lime[300]),
    backgroundColor: lime[300]
  }
}));

const classNameHolder = [
  'purple',
  'indigo',
  'blue',
  'lightBlue',
  'cyan',
  'teal',
  'green',
  'lightGreen',
  'lime',
  'deepPurple'
];

const options = {
  filterType: 'textField',
  selectableRows: 'none'
};

const StoreAdminUsers = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { profile = {}, profile: { stores = [] }, activeStoreUsers = [] } = useSelector((state) => state.user);
  const filteredUsers = activeStoreUsers.filter((user) => user.id !== profile._id);

  useEffect(() => {
    if (!activeStoreUsers.length) {
      getActiveStoreUsersApi({dispatch});
    }
  }, []);


  const handleUnassignUser = (email) => {
    const [{apiUrl}] = stores;
    deleteUserStoreAPI({dispatch, apiUrl, email});
  };

  const columns = [
    {
      name: 'name',
      label: 'Name',
      options: {
        filterOptions: {
          fullWidth: true,
        },
        customBodyRenderLite: (dataIndex) => {
          const {name, initials} = filteredUsers[dataIndex];
          return (
            <div className="flex flex-wrap items-center">
              <Avatar
                className={`mr-4 text-14 ${classes[classNameHolder[Math.floor(Math.random() * 10)]]}`}
              >
                {initials}
              </Avatar>
              {name}
            </div>
          );
        }
      }
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        filterOptions: {
          fullWidth: true,
        }
      }
    },
    {
      name: 'action',
      label: 'Action',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({className: 'text-14 w-200'}),
        customBodyRenderLite: (dataIndex) => {
          const {email} = filteredUsers[dataIndex];
          return (
            <div className="flex items-center">
              <IconButton
                onClick={() => handleUnassignUser(email)}
                title="Unassign user from store"
              >
                <Icon>delete</Icon>
              </IconButton>
            </div>
          );
        },
      }
    },
  ];
  return (
    <div>
      <MUIDataTable
        className="mt-10"
        title={'Users'}
        data={filteredUsers}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default StoreAdminUsers;
